function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M35.547,42.431l-3.182-3.182l-2.121,2.121l3.182,3.182c0.586,0.586,1.536,0.586,2.121,0   S36.133,43.017,35.547,42.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M38.547,24.431l-3.182-3.182l-2.121,2.121l3.182,3.182c0.586,0.586,1.536,0.586,2.121,0   S39.133,25.017,38.547,24.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M12.683,42.431l3.182-3.182l2.121,2.121l-3.182,3.182c-0.586,0.586-1.536,0.586-2.121,0   S12.097,43.017,12.683,42.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M9.433,24.431l3.182-3.182l2.121,2.121l-3.182,3.182c-0.586,0.586-1.536,0.586-2.121,0   S8.847,25.017,9.433,24.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DD0E1"
    },
    d: "M38,8c0-1.933-1.149-3-3.231-3S31,7.567,31,9.5c0,1,1.923,1.5,3,1.5C36.082,11,38,9.933,38,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DD0E1"
    },
    d: "M10,8c0-1.933,1.149-3,3.231-3S17,7.567,17,9.5c0,1-1.923,1.5-3,1.5C11.918,11,10,9.933,10,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424242"
    },
    cx: 35,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424242"
    },
    cx: 13,
    cy: 8,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DD0E1"
    },
    d: "M37,34c0,4.774-3.219,10-13.31,10C15.568,44,11,38.774,11,34c0-5,1-5.806,1-10c0-4.688,0-7,0-10  c0-4.774,3.076-11,11.69-11S36,6.991,36,13c0,3-0.237,5.453,0,10C36.186,26.562,37,31,37,34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 29,
    cy: 10,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 19,
    cy: 10,
    r: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M24,20c0,0.552,0.448,1,1,1s1-0.448,1-1v-3h-2V20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M22,20c0,0.552,0.448,1,1,1s1-0.448,1-1v-3h-2V20z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M26.5,18c-0.412,0-0.653-0.085-1.011-0.205c-0.975-0.328-2.021-0.326-2.996,0.002  C22.138,17.916,21.91,18,21.5,18c-1.334,0-1.5-1-1.5-1.5c0-1.5,1.5-2.5,3-2.5c0.835,0,1.165,0,2,0c1.5,0,3,1,3,2.5  C28,17,27.834,18,26.5,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424242"
    },
    cx: 27,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424242"
    },
    cx: 17,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#424242"
    },
    cx: 24,
    cy: 14,
    rx: 2,
    ry: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolang);
export default __webpack_public_path__ + "static/media/golang.79b6532b6da5893b73c0744e2010f43b.svg";
export { ForwardRef as ReactComponent };